/*
 * @Descripttion:
 * @version:
 * @Author: jing
 * @Date: 2020-09-15 10:23:04
 * @LastEditors: jing
 * @LastEditTime: 2020-12-15 15:27:29
 */
const baseUrl = `http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard3/`;
const projectUrl = `http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard3/projectList/`;
const videoList = {
  gfsf: [
    {
      videosrc: `${baseUrl}qw.mp4`,
      main_img: `${baseUrl}cover-qw2.jpeg`,
      title: "区位",
      times: 1234,
      id: 1,
      showTitle: false
    },
    {
      videosrc: `${baseUrl}st.mp4`,
      main_img: `${baseUrl}cover-st2.jpeg`,
      title: "生态",
      times: 1234,
      id: 2,
      showTitle: false
    },
    {
      videosrc: `${baseUrl}wy.mp4`,
      main_img: `${baseUrl}cover-wy2.jpeg`,
      title: "物业",
      times: 1234,
      id: 3,
      showTitle: false
    }
  ],
  twsf: [
    {
      videosrc: `${baseUrl}video_zhyshjg.mp4`,
      main_img: `${baseUrl}cover-jg.jpeg`,
      title: "景观",
      times: 1234,
      id: 4,
      showTitle: false
    },
    {
      videosrc: `${baseUrl}125%E5%AE%A4%E5%86%85.mp4`,
      main_img: `${baseUrl}cover-hx.jpeg`,
      title: "户型",
      times: 123,
      id: 5,
      showTitle: false
    },
    // {
    //   videosrc: `${baseUrl}125%E6%88%B7%E5%9E%8B%E5%B1%95%E7%A4%BA.mp4`,
    //   main_img: `${baseUrl}poster_125hx.png`,
    //   title: "户型",
    //   times: 1234,
    //   id: 5
    // },
    {
      videosrc: `${baseUrl}ybj.mp4`,
      main_img: `${baseUrl}cover-ybj.jpeg`,
      title: "样板间",
      times: 123,
      id: 6,
      showTitle: false
    }
  ]
};
const project = {
  banner: `${projectUrl}banner.png`,
  list: [
    {
      type: 2,
      time: "2020年12月5日",
      t:
        "首发 | 春山秋水 / 165㎡ 气质大宅，诗意东方，安然静谧【环球设计2433期】",
      title: "",
      imgsrc: `${projectUrl}s1.jpeg`,
      url: "https://mp.weixin.qq.com/s/I_BcnhUvh4VYH9FEeOXcFw"
    },
    {
      type: 1,
      time: "2020年12月9日",
      t: "中海映山湖·央墅：我的自白",
      title: "",
      imgsrc: `${projectUrl}s2.png`,
      url: "https://mp.weixin.qq.com/s/rCJnGzjIJFbJjpvf4EqIvQ"
    },
    {
      type: 2,
      time: "2020年11月21日",
      t: "映事月刊丨初冬已至，家书暖先行",
      title: "",
      imgsrc: `${projectUrl}s3.png`,
      url: "https://mp.weixin.qq.com/s/iZAFavi7Td-eAu0AoqAK4g"
    },
    {
      type: 1,
      time: "2019年11月19日",
      t: "中海映山湖：40年，我们再出发",
      title: "",
      imgsrc: `${projectUrl}s4.jpeg`,
      url: "https://mp.weixin.qq.com/s/P8g5wMLsLS1hueR1oUQTmg"
    },
    {
      type: 1,
      time: "2020年3月24日",
      t: "排队买楼不知价，只因市民信任他",
      title: "",
      imgsrc: `${projectUrl}s5.png`,
      url: "https://mp.weixin.qq.com/s/lO79ySm2Iofd4TrcxCvh5A"
    },
    {
      type: 2,
      time: "2020年4月6日",
      t: "住在诗里是一种什么体验？",
      title: "",
      imgsrc: `${projectUrl}s6.jpeg`,
      url: "https://mp.weixin.qq.com/s/cYRitnQcgZaM_ro8lRFCow"
    },
    {
      type: 1,
      time: "2020年6月21日",
      t: "中海映山湖·央墅 | 择隐山水 淡然天下",
      title: "",
      imgsrc: `${projectUrl}s7.png`,
      url: "https://mp.weixin.qq.com/s/CC3uMQnG9g2icztWd913jg"
    },
    {
      type: 1,
      time: "2020年6月29日",
      t: "超500项服务标准，映山湖四色花物业体系来了！",
      title: "",
      imgsrc: `${projectUrl}s8.jpeg`,
      url: "https://mp.weixin.qq.com/s/GshqZWfzqy8T4p4XmFMEvQ"
    }
  ]
};
export { videoList, project };
